var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about pa-6"},[_c('h1',[_vm._v("Acerca de Metalist")]),_c('p',[_vm._v("Un sitio para crear listas con diferentes objetivos.")])])
}]

export { render, staticRenderFns }